export class NativeStandardBackupPolicyPlan {
    'backupSchedules';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<NativeStandardBackupSchedules>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStandardBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
